import React, { Component } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { firebaseAuth , firestore } from "./Firebase";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { doc, collection, getDocs, getDoc } from "firebase/firestore"; 

export default class Login extends Component {

  constructor(props){
    super(props);
    this.state={
      MNumber: "",
      password: "",
      Captcha : false,
      otp: "",
      fill1:false,
      fill2:false,
      fill3:false,
      fill4:false,
    }
  }

  setUpCaptcha = (Number) =>{
    const recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {}, firebaseAuth);
    recaptchaVerifier.render();
    return signInWithPhoneNumber(firebaseAuth, Number, recaptchaVerifier)
  }
  
  onSubmitNumber = async (e) =>{
    e.preventDefault();
     try{
         const response = await this.setUpCaptcha(this.state.MNumber);
         console.log(response)
         this.setState({
             confirmationResult:response,
             Captcha : true,
         })
      }catch(err){
        if(err.message === 'Firebase: Error (auth/too-many-requests).'){
          alert('Too many requests Please try again later')
        }else{
          alert(err.message)
        }
      }
  }
  OnSubmitNumber1 = async (e) =>{
    e.preventDefault();

    const validation = await this.validateFields();
    if(!this.state.fill1 && !this.state.fill2 && !this.state.fill4 && !validation){
      const Users = [];
      const Admins = [];

      const querySnapshot = await getDocs(collection(firestore, "Users"));
      const querySnapshotAdmin = await getDocs(collection(firestore, "Admins"));

      querySnapshot.forEach((doc) => {
        Users.push(doc.data().UserNumber);
      });

      querySnapshotAdmin.forEach((doc) => {
        Admins.push(doc.data().UserNumber);
      });

      let flag = 0, adminFlag = 0 ;
      for (let i = 0, j = 0; i < Users.length, j < Admins.length; i++, j++) {
        if(Admins[j]=== this.state.MNumber){
          adminFlag = 1;
          break;
        }
        if(Users[i]=== this.state.MNumber){
          flag = 1;
          break;
        }
      }
      if(adminFlag===1){
        console.log('Admin Present please Login')
        const docSnap = await getDoc(doc(firestore, "Admins", this.state.MNumber));
        const UserPassword = docSnap.data().Password
        if(this.state.password === UserPassword){
          this.onSubmitNumber(e)
        }else{
          alert('Invalid Password')
        }
      }else if(flag===1){
        console.log('User Present please Login')
        const docSnap = await getDoc(doc(firestore, "Users", this.state.MNumber));
        const UserPassword = docSnap.data().Password
        if(this.state.password === UserPassword){
          this.onSubmitNumber(e)
        }else{
          alert('Invalid Password')
        }
      }else{
        console.log('User not Present please Register')
        alert('User does not exist please Register')
      }
    }
    
  }

  handleOTP = async (e) =>{
    e.preventDefault();
    const validationOTP = await this.validateOTP();
    if(!this.state.fill3 && !this.state.fill5 && !validationOTP){
      try{
        const result = await this.state.confirmationResult.confirm(this.state.otp);
        console.log(result.user.uid)
        this.props.navigate('/FaceVerify')
      }catch(err){
        if(err.message === 'Firebase: Error (auth/invalid-verification-code).'){
          alert('Invalid OTP')
        }else{
          alert(err.message)
        }
      }
    }
  }

  handleNumberValue=(e)=>{
    if((e.key !== "" && e.key >= '0' && e.key <='9') || e.key === "Backspace" || e.key === "Delete" || e.key ==='+'){
      return true
    }else{
      return e.preventDefault()
    }
  }

  validateFields = () => {
    let error = false;
    if(this.state.MNumber===''){
      error = true;
      this.setState({
        fill1:true
      })
    }
    else{
      this.setState({
        fill1:false
      })
    }
    if(this.state.MNumber.length < 13){
      error = true;
      this.setState({
        fill4:true
      })
    }
    else{
      this.setState({
        fill4:false
      })
    }
    if(this.state.password===''){
      error = true;
      this.setState({
        fill2:true
      })
    }
    else{
      this.setState({
        fill2:false
      })
    }
    return error
  }

  validateOTP = () => {
    let errorOTP = false;
    if(this.state.otp===''){
      errorOTP = true;
      this.setState({
        fill3:true
      })
    }
    else{
      this.setState({
        fill3:false
      })
    }
    if(this.state.otp.length < 6){
      errorOTP = true;
      this.setState({
        fill5:true
      })
    }
    else{
      this.setState({
        fill5:false
      })
    }
    return errorOTP
  }

  render() {
    const {fill1,fill2,fill3,fill4,fill5} = this.state
    return (
      <div className='LS1'>
        <div className='LS1-1'>
          <form>
            {this.state.Captcha ? <ul className='OTPDiv'>
              <h1>LOGIN</h1>
              <li className='OTPli'>
                <div>
                  <input type='tel' value={this.state.otp} placeholder='OTP' maxLength={6} onKeyDown={(e)=>this.handleNumberValue(e)} onChange={(e)=>{this.setState({otp: e.target.value})}}></input>
                  {fill3?<span className='Warnings'>Please fill data</span>:""}
                  {fill5?<span className='Warnings'>Please enter a valid OTP</span>:""}
                </div>
              </li>
              <li><button onClick={(e)=> this.handleOTP(e)}>LOGIN</button></li>
            </ul>
            :<ul>
              <h1>LOGIN</h1>
              <li>
                <div>
                  <input type='tel' placeholder='Number (Enter +91 before your number)' maxLength={13} onKeyDown={(e)=>this.handleNumberValue(e)} onChange={(e)=>{this.setState({MNumber: e.target.value})}}></input>
                  {fill1?<span className='Warnings'>Please fill data</span>:""}
                  {fill4?<span className='Warnings'>Please enter a valid number</span>:""}
                </div>
              </li>
              <li>
                <div>
                  <input type='password' placeholder='Password' onChange={(e)=>{this.setState({password: e.target.value})}}></input>
                  {fill2?<span className='Warnings'>Please fill data</span>:""}
                </div>
              </li>
              <div className='Captcha' id='recaptcha-container'></div>
              <li><button type='submit' onClick={(e)=>{this.OnSubmitNumber1(e)}}>LOGIN</button></li>
            </ul>}
            {this.state.Captcha ? <></> :<span>Don't have an Account? <Link to='/Register'>Sign Up here!</Link> </span>}
          </form>
        </div>
      </div>
    )
  }
}
export function LoginH (props){
  const navigate = useNavigate()
  return(<Login navigate={navigate}/>)
}